var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFaceHappy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29 6.64581C16.6541 6.64581 6.64584 16.6541 6.64584 29C6.64584 41.3458 16.6541 51.3541 29 51.3541C41.3459 51.3541 51.3542 41.3458 51.3542 29C51.3542 16.6541 41.3459 6.64581 29 6.64581ZM3.02084 29C3.02084 14.6521 14.6521 3.02081 29 3.02081C43.3479 3.02081 54.9792 14.6521 54.9792 29C54.9792 43.3479 43.3479 54.9791 29 54.9791C14.6521 54.9791 3.02084 43.3479 3.02084 29ZM20.2939 37.5873C20.89 36.7831 22.0251 36.6145 22.8293 37.2105C24.5895 38.5152 26.7141 39.2708 29 39.2708C31.2859 39.2708 33.4105 38.5152 35.1707 37.2105C35.9749 36.6145 37.11 36.7831 37.7061 37.5873C38.3022 38.3915 38.1335 39.5267 37.3293 40.1227C34.9793 41.8646 32.1054 42.8958 29 42.8958C25.8947 42.8958 23.0207 41.8646 20.6707 40.1227C19.8665 39.5267 19.6978 38.3915 20.2939 37.5873Z",
    fill: "#64D7FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6667 25.375C38.6667 27.377 37.5847 29 36.25 29C34.9153 29 33.8333 27.377 33.8333 25.375C33.8333 23.3729 34.9153 21.75 36.25 21.75C37.5847 21.75 38.6667 23.3729 38.6667 25.375Z",
    fill: "#64D7FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1667 25.375C24.1667 27.377 23.0847 29 21.75 29C20.4153 29 19.3333 27.377 19.3333 25.375C19.3333 23.3729 20.4153 21.75 21.75 21.75C23.0847 21.75 24.1667 23.3729 24.1667 25.375Z",
    fill: "#64D7FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceHappy);
export default __webpack_public_path__ + "static/media/face-happy.c9e8d8b0.svg";
export { ForwardRef as ReactComponent };